import { BaseChannel } from "@/api/ws/channels/BaseChannel";

export class ChatPrivateChannel extends BaseChannel {
  name = "borrower_platform.ai_agent_sessions";
  isPrivate = true;
}
